@if (row) {
<div class="date-various">
  <div class="form-inline date-various-row">
    <div class="form-group various-checkbox">
      <input type="checkbox"
             [checked]="isVarious"
             title="Various"
             (change)="toggleVarious($event)">
    </div>
    <div class="form-group various-input">
      @if (!isVarious) {
<input
             type="date"
             class="form-control input-md"
             [value]="formatDateForInput(row.ATTRIB_VALUE)"
             (change)="onDateSelected($event)">
}
      @if (isVarious) {
<input
             type="text"
             class="form-control input-md"
             size="15"
             disabled
             value="VARIOUS">
}
    </div>
  </div>
</div>
}
